module.exports = __webpack_public_path__ + "img/link.a38aac85.svg";